import { useFeatureValue } from '@growthbook/growthbook-react';
import { Event, CalendarMonth } from '@mui/icons-material';
import { Menu, MenuItem, MenuList } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { FEATURE_TOGGLE } from '@/constants/featuretoggle';
import { JobTypeEnum } from '@/types/graphql';
import { trackOrderCreationStarted } from '@/util/vexo';

type LtaGigMenuProps = {
  anchorEl: any;
  open: boolean;
  handleCloseMenu: () => void;
  marginTop?: number;
  useV2?: boolean;
};

export const LtaGigMenu = ({
  anchorEl,
  open,
  handleCloseMenu,
  marginTop = 5,
  useV2 = false,
}: LtaGigMenuProps) => {
  // V2 lives under its own `/orders-v2/*` namespace; the legacy creator
  // stays under `/orders/creategigorder`.
  const orderCreatePath = useV2
    ? '/orders-v2/create'
    : '/orders/creategigorder';
  const navigate = useNavigate();
  return (
    <Menu
      MenuListProps={{
        'aria-labelledby': 'basic-button',
      }}
      PaperProps={{
        sx: {
          border: '1px solid #D3D3D3',
          filter:
            'drop-shadow(0px 4.050473213195801px 4.050473213195801px rgba(0, 0, 0, 0.05))',
          boxShadow: 'none',
          marginTop: `${marginTop}px`,
        },
      }}
      anchorEl={anchorEl}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      id="basic-menu"
      open={open}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClose={handleCloseMenu}
    >
      <MenuList dense={true} sx={{ paddingTop: '0px', paddingBottom: '0px' }}>
        <MenuItem
          id="new_order_gig"
          onClick={() => {
            trackOrderCreationStarted({ order_type: 'GIG' });
            navigate(`${orderCreatePath}?type=${JobTypeEnum.GIG}`);
          }}
        >
          <Event
            fontSize="small"
            htmlColor={'#7A7A7A'}
            style={{ marginRight: '10px' }}
          />
          <p style={{ color: '#262626', fontSize: '16px' }}>Create New Gig</p>
        </MenuItem>
        <MenuItem
          id="new_order_lta"
          onClick={() => {
            trackOrderCreationStarted({ order_type: 'LTA' });
            navigate(`${orderCreatePath}?type=${JobTypeEnum.LTA}`);
          }}
        >
          <CalendarMonth
            fontSize="small"
            htmlColor={'#7A7A7A'}
            style={{ marginRight: '10px' }}
          />
          <p style={{ color: '#262626', fontSize: '16px' }}>Create New LTA</p>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
